<style src="./Terminal.scss" lang="scss"></style>
<template>
  <li class="Terminal">
    <span class="title">{{ terminalInfo.terminalName }}</span>
    <ParkingIllustration class="illustration" />
    <section class="statuscontent">
      <fieldset class="field">
        <p class="label">Setor</p>
        <p class="info">{{ terminalInfo.parkingName }}</p>
      </fieldset>
      <fieldset class="field">
        <p class="label">Últm. Att.</p>
        <p class="info">09/04/2025 21:38:09</p>
      </fieldset>
      <fieldset class="field">
        <p class="label">Impressões</p>
        <p class="info">
          {{ terminalInfo.ticket && terminalInfo.ticket.regularCount }}
        </p>
      </fieldset>
    </section>
    <section class="warnings">
      <span class="atmopened" v-if="terminalIsOpened">ATM ABERTO</span>
    </section>
  </li>
</template>

<script>
import ParkingIllustration from '../illustration/Parking.vue';

export default {
  name: 'AtmMap',
  components: { ParkingIllustration },
  props: {
    terminalInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showSpinner: false,
    };
  },
  computed: {
    terminalIsOpened() {
      return this.terminalInfo && this.terminalInfo.closureState;
    },
  },
};
</script>
